import { render, staticRenderFns } from "./twoFactorAuthenticationModal.vue?vue&type=template&id=12d2db30&scoped=true"
import script from "./twoFactorAuthenticationModal.vue?vue&type=script&lang=js"
export * from "./twoFactorAuthenticationModal.vue?vue&type=script&lang=js"
import style0 from "./twoFactorAuthenticationModal.vue?vue&type=style&index=0&id=12d2db30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2db30",
  null
  
)

export default component.exports